import {
    IApiErrorMessages,
    IApproveMonthlyOrderAPI,
    IIncludeTypeAPI,
    IInvoiceAPI,
    IInvoicesListAPI,
    IItemAPI,
    IMonthlyOrderPostLinkUnlinkAPI,
    IMonthlyOrderPostPoNumber,
    IMultiEnabled,
    IParamsList,
    IRateListRequestAPIV2,
    IRequestTariffPackageInstanceItemAPI,
} from '../interfaces';
import { IMapField } from '../instruments';

export type IApiUrl = string;
export type IHeaderType = 'access' | 'refresh' | 'uploadFile' | 'none';

export type IGetRestApi = {
    apiType: IGetApiType;
    body?: IRequestAPIBody;
    headerType: IHeaderType;
    method: IAPIMethod;
    url: IApiUrl;
};

export type IPostFileRestApi = {
    apiType: IGetApiType;
    body?: IRequestAPIBody;
    file?: Blob;
    headerType: IHeaderType;
    method: IAPIMethod;
    url: IApiUrl;
};

export type IAbortControllers = {
    [id: string]: AbortController;
};

export type IGetApiParams = {
    apiType: IGetApiType;
    body?: IRequestAPIBody;
    errorStatus: Array<number>;
    file?: File;
    headerType: IHeaderType;
    isGetFile?: boolean;
    isNotCheckToken?: boolean;
    isNotLoader?: boolean;
    isPostFile?: boolean;
    method: IAPIMethod;
    okStatus: Array<number>;
    url: IApiUrl;
};

export type IApiParams = {
    id?: string;
    companyId?: string;
    idList?: Array<string>;
    itemId?: string;
    mcc?: Array<string>;
    salesRateListId?: string;
    scope?: Array<string>;
    searchParamsList?: IParamsList;
    subscriptionId?: string;
};

export type IAPIMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT';

export const HTTP_STATUS = {
    END_POINT_ERROR_404: 404,
    GET_NOT_FOUND_404: 404,
    GET_OK_200: 200,
    GET_OK_202: 202,
    DELETE_OK_204: 204,
    INCORRECT_REQUEST: 0,
    PATCH_DATA_ERROR_422: 422,
    PATCH_DATA_OK_200: 200,
    POST_DATA_ACCEPTED_202: 202,
    POST_DATA_ERROR_422: 422,
    POST_DATA_OK_201: 201,
    SUCCESS_WITHOUT_BODY_204: 204,
    SERVER_ERROR_500: 500,
    POLICY_ERROR_400: 400,
    TOKEN_GET_POST_PATCH_ERROR_401: 401,
    TOKEN_LOGIN_ERROR_404: 404,
    TOKEN_LOGIN_OK_201: 201,
    TOKEN_LOGOUT_OK_500: 500,
    TOKEN_LOGOUT_OK_204: 204,
    TOKEN_UPDATE_OK_201: 201,
};

export type IGetApiType =
    | 'APP_SIGNAL'
    | 'APPLICATION'
    | 'CREATE_COMPANY_SUBSCRIPTION'
    | 'DELETE_BILLING_SYSTEM_INVOICE_NUMBER'
    | 'DELETE_BILLING_SYSTEM_NON_RECURRING_PAYMENTS'
    | 'DELETE_BILLING_SYSTEM_ORDER'
    | 'DELETE_BLOB'
    | 'DELETE_CARD_SET'
    | 'DELETE_CARD_SUBSCRIBERS'
    | 'DELETE_CARD_WITH_SUBSCRIBERS'
    | 'DELETE_CARDS'
    | 'DELETE_CARDS_CSV'
    | 'DELETE_COMPANY'
    | 'DELETE_COMPANY_API_KEY'
    | 'DELETE_COMPANY_MONTHLY_PAYMENTS'
    | 'DELETE_COMPANY_NON_RECURRING_PAYMENTS'
    | 'DELETE_COMPANY_SUBSCRIPTION'
    | 'DELETE_COMPANY_TENANT_CONFIG'
    | 'DELETE_COUNTRY'
    | 'DELETE_CURRENCY'
    | 'DELETE_OPERATOR'
    | 'DELETE_OPERATOR_INTERACTIONS_FILES'
    | 'DELETE_PACKAGE'
    | 'DELETE_PACKAGE_INSTANCE'
    | 'DELETE_PURCHASE_RATE_LIST'
    | 'DELETE_REPORT'
    | 'DELETE_SALES_RATE_LIST'
    | 'DELETE_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2'
    | 'DELETE_SALES_RATE_LIST_COMPANY'
    | 'DELETE_SALES_RATE_LIST_ENTRIES_V2'
    | 'DELETE_SUBSCRIBER'
    | 'DELETE_SUBSCRIBER_V2'
    | 'DELETE_TARIFF'
    | 'DELETE_TARIFF_PACKAGE'
    | 'DELETE_TARIFF_TARIFF_PACKAGE_ASSOCIATION'
    | 'DELETE_USER'
    | 'DELETE_USER_IMPERSONATION'
    | 'DELETE_ZONE'
    | 'EDIT_SOLD_PACKAGE'
    | 'GET_ACCEPTANCE_DOCUMENTS'
    | 'GET_ACTIVITY_LOGS'
    | 'GET_ACTIVITY_ROLL'
    | 'GET_ASSET_ASSIGNMENTS_FUTURE_LIST'
    | 'GET_ASSET_ASSIGNMENTS_PARENT_BLOCKED_LIST'
    | 'GET_ASSIGNED_CARDS_SELECT'
    | 'GET_BALANCE_LOG_LIST'
    | 'GET_BILLING_SYSTEM_COMPANIES_LIST'
    | 'GET_BILLING_SYSTEM_COMPANIES_SELECT'
    | 'GET_BILLING_SYSTEM_INVOICE_NUMBER'
    | 'GET_BILLING_SYSTEM_NON_RECURRING_PAYMENTS'
    | 'GET_BILLING_SYSTEM_ORDER'
    | 'GET_BILLING_SYSTEM_ORDERS'
    | 'GET_BOUGHT_PACKAGES'
    | 'GET_BOUGHT_PACKAGES_SELECT'
    | 'GET_CALL_DATA_RECORDS_COUNT'
    | 'GET_CALL_DATA_RECORDS_LAST_5'
    | 'GET_CALL_DATA_RECORDS_LIST'
    | 'GET_CALL_DATA_SQUASHED_RECORDS_COUNT'
    | 'GET_CALL_DATA_SQUASHED_RECORDS_LIST'
    | 'GET_CARD'
    | 'GET_CARD_DEVICE_FILES'
    | 'GET_CARD_LIST'
    | 'GET_CARD_LIST_COUNT'
    | 'GET_CARD_SET'
    | 'GET_CARD_SET_COMBINATION'
    | 'GET_CARD_SET_COMBINATION_SUBSCRIBERS'
    | 'GET_CARD_SET_CSV'
    | 'GET_CARD_SET_HIERARCHY'
    | 'GET_CARD_SET_MANAGE_CARDS'
    | 'GET_CARD_SET_MANAGE_COMPANIES_CHILDREN'
    | 'GET_CARD_SET_OWNER_COMPANIES'
    | 'GET_CARD_SETS_LIST'
    | 'GET_CARD_SETS_SELECT'
    | 'GET_CARD_STATISTICS'
    | 'GET_COMBINATION_CARDS_SELECT'
    | 'GET_COMPANIES_CHILDREN_SELECT'
    | 'GET_COMPANIES_HIERARCHY'
    | 'GET_COMPANIES_LIST'
    | 'GET_COMPANIES_SELECT'
    | 'GET_COMPANY'
    | 'GET_COMPANY_ABOUT'
    | 'GET_COMPANY_API_KEY'
    | 'GET_COMPANY_CONFIG'
    | 'GET_COMPANY_CONFIG_MFA_SELECT'
    | 'GET_COMPANY_HIERARCHY_V2'
    | 'GET_COMPANY_LOGO'
    | 'GET_COMPANY_MONTHLY_PAYMENTS'
    | 'GET_COMPANY_NON_RECURRING_PAYMENTS'
    | 'GET_COMPANY_NRC_COUNT_CARDS'
    | 'GET_COMPANY_STATISTICS'
    | 'GET_COMPANY_SUBSCRIPTION'
    | 'GET_COMPANY_TYPES_SELECT'
    | 'GET_COUNTRIES_LIST'
    | 'GET_COUNTRIES_SELECT'
    | 'GET_COUNTRY'
    | 'GET_COUNTRY_ACTIVE_CARDS'
    | 'GET_CURRENCY'
    | 'GET_CURRENCY_LIST'
    | 'GET_CURRENCY_SELECT'
    | 'GET_DATA_UNIT_TYPE_SELECT'
    | 'GET_DIAMETER_SESSIONS_LIST'
    | 'GET_ENTITY_SELECT'
    | 'GET_ES_PLUS_NOTIFICATIONS_LIST'
    | 'GET_ES_PLUS_NOTIFICATIONS_LIST_CSV'
    | 'GET_ES_PLUS_NOTIFICATIONS_LOGS_LIST'
    | 'GET_ES_PLUS_NOTIFICATIONS_LOGS_LIST_CSV'
    | 'GET_ES_PLUS_NOTIFICATIONS_QR_CODES_LIST'
    | 'GET_ES_PLUS_NOTIFICATIONS_QR_CODES_LIST_CSV'
    | 'GET_FEATURE_FLAG_LIST_ALL'
    | 'GET_FEATURE_FLAG_RULES'
    | 'GET_FINANCE_ROLL'
    | 'GET_GEOTRACKING_CARD_LIST'
    | 'GET_GEOTRACKING_CARD_LOCATION_HISTORY'
    | 'GET_INVOICE'
    | 'GET_INVOICES_LIST'
    | 'GET_INVOICES_MONTHLY_TOTALS'
    | 'GET_MONTHLY_ORDER'
    | 'GET_MONTHLY_ORDER_AVAILABLE_ORDERS'
    | 'GET_MONTHLY_ORDERS_LIST'
    | 'GET_MONTHLY_USAGE_INVOICES'
    | 'GET_MONTHLY_USAGE_REPORTS'
    | 'GET_MY_PURCHASES_LIST'
    | 'GET_NETWORKS_SELECT'
    | 'GET_ONE_PACKAGE'
    | 'GET_ONE_PACKAGE_INSTANCE'
    | 'GET_ONE_PACKAGE_TO_BUY'
    | 'GET_ONE_SOLD_PACKAGE'
    | 'GET_OPERATOR'
    | 'GET_OPERATOR_ACTIVITY'
    | 'GET_OPERATOR_INTERACTIONS_COMMANDS_SELECT'
    | 'GET_OPERATOR_INTERACTIONS_FILES'
    | 'GET_OPERATOR_INTERACTIONS_FILES_SELECT'
    | 'GET_OPERATOR_INTERACTIONS_GATEWAYS_SELECT'
    | 'GET_OPERATOR_INTERACTIONS_RESPONSE'
    | 'GET_OPERATOR_INTERACTIONS_RESPONSES'
    | 'GET_OPERATOR_INTERACTIONS_RESPONSES_CSV'
    | 'GET_OPERATORS_GATEWAYS_SELECT'
    | 'GET_OPERATORS_LIST'
    | 'GET_OPERATORS_SELECT'
    | 'GET_OPERATORS_SELECT_ALL'
    | 'GET_ORDER'
    | 'GET_ORDER_ORDERABLES_SELECT'
    | 'GET_ORDERS_LIST'
    | 'GET_ORIGINAL_UNIT_TYPE_SELECT'
    | 'GET_PACKAGE_INSTANCES'
    | 'GET_PACKAGES'
    | 'GET_PACKAGES_SOLD'
    | 'GET_PACKAGES_TO_BUY'
    | 'GET_PACKAGES_UNITS_LOGS_LIST'
    | 'GET_PAPER_TRAIL_LOGS_LIST'
    | 'GET_PAYMENT_SELECT'
    | 'GET_PROFILE_ABOUT'
    | 'GET_PURCHASE_RATE_LIST'
    | 'GET_PURCHASE_RATES_LIST'
    | 'GET_RATE_UNIT_TYPE_SELECT'
    | 'GET_REPORT_LIST'
    | 'GET_REVENUE_CARD_SET_LIST'
    | 'GET_REVENUE_CARDS_LIST'
    | 'GET_REVENUE_COMPANY_LIST'
    | 'GET_REVENUE_COUNTRY_LIST'
    | 'GET_REVENUE_TELECOM_LIST'
    | 'GET_REVENUE_TIMELINE_LIST'
    | 'GET_REVENUE_ZONE_LIST'
    | 'GET_SALES_RATE_CSV'
    | 'GET_SALES_RATE_IMPORT'
    | 'GET_SALES_RATE_IMPORT_LIST'
    | 'GET_SALES_RATE_IMPORT_TYPE_SELECT'
    | 'GET_SALES_RATE_LIST'
    | 'GET_SALES_RATE_LIST_V2'
    | 'GET_SALES_RATES_LIST'
    | 'GET_SALES_RATES_LIST_V2'
    | 'GET_SALES_RATES_SELECT'
    | 'GET_SERVER_NOTIFICATIONS'
    | 'GET_SERVER_NOTIFICATIONS_COUNTERS'
    | 'GET_SERVER_NOTIFICATIONS_NEW'
    | 'GET_SUBSCRIBER'
    | 'GET_SUBSCRIBER_V2'
    | 'GET_SUBSCRIBERS_BY_CARD_ID'
    | 'GET_SUBSCRIBERS_LIST'
    | 'GET_SUBSCRIBERS_LIST_CSV'
    | 'GET_SUBSCRIBERS_LIST_CSV_V2'
    | 'GET_SUBSCRIBERS_LIST_V2'
    | 'GET_SUBSCRIBERS_STATUS'
    | 'GET_SUBSCRIBERS_STATUS_SELECT'
    | 'GET_SUBSCRIBERS_STATUSES'
    | 'GET_TARIFF'
    | 'GET_TARIFF_CARDS'
    | 'GET_TARIFF_COMPANY_SELECT_CHILDREN'
    | 'GET_TARIFF_PACKAGE'
    | 'GET_TARIFF_PACKAGE_INSTANCE'
    | 'GET_TARIFF_PACKAGE_INSTANCE_CARDS'
    | 'GET_TARIFF_PACKAGE_INSTANCE_LIST'
    | 'GET_TARIFF_PACKAGE_INSTANCE_STATISTICS'
    | 'GET_TARIFF_PACKAGE_TO_BUY'
    | 'GET_TARIFF_PACKAGES'
    | 'GET_TARIFF_PACKAGES_STATISTICS'
    | 'GET_TARIFF_TO_BUY'
    | 'GET_TARIFFS'
    | 'GET_TARIFFS_PACKAGES_TO_BUY'
    | 'GET_TARIFFS_TO_BUY'
    | 'GET_USAGE_CARD_SETS_LIST'
    | 'GET_USAGE_CARDS_LIST'
    | 'GET_USAGE_COMPANY_LIST'
    | 'GET_USAGE_COUNTRY_LIST'
    | 'GET_USAGE_TELECOM_LIST'
    | 'GET_USAGE_TIMELINE_LIST'
    | 'GET_USAGE_ZONE_LIST'
    | 'GET_USER'
    | 'GET_USER_PROFILE'
    | 'GET_USER_TYPE_SELECT'
    | 'GET_USERS_BY_COMPANY_SELECT'
    | 'GET_USERS_LIST'
    | 'GET_USERS_SELECT'
    | 'GET_WHO_AM_I'
    | 'GET_ZONE'
    | 'GET_ZONE_LIST'
    | 'GET_ZONE_SELECT'
    | 'LOG_IN'
    | 'LOG_OUT'
    | 'PASSWORD_UPDATE'
    | 'PASSWORD_UPDATE_EMAIL'
    | 'PATCH_BILLING_SYSTEM_ORDER'
    | 'PATCH_CARD'
    | 'PATCH_CARD_SET'
    | 'PATCH_COMPANY'
    | 'PATCH_COMPANY_ABOUT'
    | 'PATCH_COMPANY_CONFIG'
    | 'PATCH_COMPANY_SETTINGS'
    | 'PATCH_COMPANY_SUBSCRIPTION'
    | 'PATCH_COUNTRY'
    | 'PATCH_CURRENCY'
    | 'PATCH_FEATURE_FLAGS'
    | 'PATCH_MONTHLY_ORDER_PO_NUMBER'
    | 'PATCH_OPERATOR'
    | 'PATCH_OPERATOR_INTERACTIONS_FILES'
    | 'PATCH_PACKAGE'
    | 'PATCH_PACKAGE_INSTANCE'
    | 'PATCH_PASSWORD'
    | 'PATCH_PURCHASE_RATE_LIST'
    | 'PATCH_SALES_RATE_LIST'
    | 'PATCH_SALES_RATE_LIST_COMPANY'
    | 'PATCH_SERVER_NOTIFICATION'
    | 'PATCH_SERVER_NOTIFICATION_NEW'
    | 'PATCH_SUBSCRIBER'
    | 'PATCH_SUBSCRIBER_V2'
    | 'PATCH_SUBSCRIBERS_FEATURES'
    | 'PATCH_TARIFF'
    | 'PATCH_TARIFF_PACKAGE'
    | 'PATCH_TARIFF_TARIFF_PACKAGE_ASSOCIATION'
    | 'PATCH_USER'
    | 'PATCH_USER_CONFIG_MFA_DISABLE'
    | 'PATCH_USER_CONFIG_MFA_ENABLE'
    | 'PATCH_ZONE'
    | 'POST_ACCEPTANCE_DOCUMENTS'
    | 'POST_ASSET_ASSIGNMENT_CANCEL'
    | 'POST_BILLING_SYSTEM_INVOICE_NUMBER'
    | 'POST_BILLING_SYSTEM_NON_RECURRING_PAYMENTS'
    | 'POST_BILLING_SYSTEM_ORDER'
    | 'POST_BILLING_SYSTEM_ORDER_APPROVE'
    | 'POST_BLOB'
    | 'POST_CALL_DATA_RECORDS'
    | 'POST_CARD_DEVICE_FILES'
    | 'POST_CARD_SET'
    | 'POST_CARD_SET_LIST_CSV'
    | 'POST_CARD_SET_REASSIGN'
    | 'POST_CARDS_LIST_CSV'
    | 'POST_COMPANY'
    | 'POST_COMPANY_API_KEY'
    | 'POST_COMPANY_MONTHLY_PAYMENTS'
    | 'POST_COMPANY_NON_RECURRING_PAYMENTS'
    | 'POST_COMPANY_SUBSCRIBERS_MIGRATE'
    | 'POST_COMPANY_SUBSCRIPTION_ORDER'
    | 'POST_COUNTRY'
    | 'POST_ES2_PLUS_CANCEL_ORDER'
    | 'POST_ES2_PLUS_CONFIRM_ORDER'
    | 'POST_ES2_PLUS_DOWNLOAD_ORDER'
    | 'POST_ES2_PLUS_RELEASE_ORDER'
    | 'POST_INVOICE'
    | 'POST_MONTHLY_ORDER_APPROVE'
    | 'POST_MONTHLY_ORDER_CANCEL'
    | 'POST_MONTHLY_ORDER_LINK_ORDER'
    | 'POST_MONTHLY_ORDER_MARK_AS_PAID'
    | 'POST_MONTHLY_ORDER_UNLINK_ORDER'
    | 'POST_NEW_ORDER'
    | 'POST_OPERATOR'
    | 'POST_OPERATOR_INTERACTIONS_FILES'
    | 'POST_ORDER_CHECKOUT'
    | 'POST_PACKAGE'
    | 'POST_PACKAGE_ORDER'
    | 'POST_PURCHASE_RATE_CSV'
    | 'POST_PURCHASE_RATE_LIST'
    | 'POST_SALES_RATE_CSV'
    | 'POST_SALES_RATE_LIST'
    | 'POST_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2'
    | 'POST_SALES_RATE_LIST_COMPANY'
    | 'POST_SALES_RATE_LIST_ENTRIES_V2'
    | 'POST_SALES_RATE_LIST_V2'
    | 'POST_SCP_FILE'
    | 'POST_SUBSCRIBERS_API_REQUEST'
    | 'POST_SUBSCRIBERS_STATUS'
    | 'POST_TARIFF'
    | 'POST_TARIFF_PACKAGE'
    | 'POST_TARIFF_TARIFF_PACKAGE_ASSOCIATION'
    | 'POST_UPLOAD_ACCEPTANCE_DOCUMENTS'
    | 'POST_USER'
    | 'POST_USER_CONFIG_MFA'
    | 'POST_USER_IMPERSONATION'
    | 'POST_ZONE'
    | 'PUT_BILLING_SYSTEM_INVOICE_NUMBER'
    | 'PUT_BILLING_SYSTEM_NON_RECURRING_PAYMENTS'
    | 'PUT_BILLING_SYSTEM_ORDER'
    | 'PUT_COMPANY_MONTHLY_PAYMENTS'
    | 'PUT_COMPANY_NON_RECURRING_PAYMENTS'
    | 'PUT_COMPANY_TENANT_CONFIG'
    | 'PUT_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2'
    | 'PUT_SALES_RATE_LIST_ENTRIES_V2'
    | 'PUT_SALES_RATE_LIST_V2'
    | 'PUT_TARIFF'
    | 'PUT_TARIFF_PACKAGE'
    | 'REFRESH_TOKEN';

export type ILoginRequest = {
    email: string;
    password: string;
    remember: boolean;
    totp: string;
};

export type ITokenResponse = {
    access?: string;
    refresh?: string;
    isError: boolean;
};

export type IGetApiResponseFile = {
    content: Blob;
    filename?: string;
    isAPIComplete: boolean;
};

export type IGetApiOk = boolean;

export type IGetApiResponse = {
    file?: IGetApiResponseFile;
    isError: boolean;
    isPolicyError?: boolean;
    resp: IBodyItemResponse | IBodyListResponse;
    errors?: IApiErrorMessages;
};

export type IGetApiResponseDictionaryType =
    | 'data_import_types'
    | 'data_unit_types'
    | 'original_unit_types'
    | 'rate_unit_types';

export type IGetApiResponseDictionaryItem = {
    // [key: string]: any;
    value: string;
    label: string;
};

export type IGetApiResponseDictionary = {
    name: IGetApiResponseDictionaryType;
    items?: IGetApiResponseDictionaryItem[];
};

export type IMeta = {
    number?: number;
    records_count?: number;
    size?: number;
    total_count?: number;
};
export type IMetaNew = {
    records_count?: number;
    page?: number;
    per_page?: number;
};

export type IBodyResponse = {
    access?: string;
    apiHost?: string;
    build_time?: string;
    companyId?: string;
    docs_accepted?: boolean;
    errors?: IApiErrorMessages;
    included?: IItemAPI[];
    invoice?: IInvoiceAPI;
    key?: string;
    meta?: IMeta;
    mfaToken?: string;
    refresh?: string;
    totpRequired?: boolean;
    version?: string;
};

export interface IGetApiResponseCount {
    count?: number;
}

export interface IBodyItemResponse extends IBodyResponse, IGetApiResponseCount {
    data?: IItemAPI;
    ReasonCode?: string;
    header?: object;
}

export interface IBodyListResponse extends IBodyResponse, IGetApiResponseCount {
    data?: IItemAPI[];
    dictionary?: IGetApiResponseDictionary[];
    invoices?: IInvoicesListAPI;
}

export type ILogoRespAPI = {
    dark_logo_url?: string;
    logo_url?: string;
    website?: string;
    custom_logo_link_url?: string;
};
export type ILogoResp = {
    logoBlack?: string;
    logoWhite?: string;
    website?: string;
    customLogoLink?: string;
};

// ToDo: 30.05.2022 - Big test API

export type IRequestMainItem = {
    id?: string;
    type: IIncludeTypeAPI;
};

export type IRequestRelationshipMainItem = IRequestMainItem & {
    id: string;
};

export interface IRelationshipItem extends IRequestRelationshipMainItem {
    destroy?: boolean;
    parentId?: string;
}

export type IRequestRelationships = {
    [type in IIncludeTypeAPI]?: {
        data?: IRequestRelationshipMainItem | IRequestRelationshipMainItem[];
    };
};

export type IRequestMainAttributesItem = IRequestMainItem & {
    attributes?: IAttributes;
};

export type IRequestIncludedItem = IRequestRelationshipMainItem & {
    attributes?: IAttributes;
};

export type IAttributes = IMapField;

export type IRequestAuthBody = {
    auth?: ILoginRequest;
    email?: string;
    password?: string;
    redirect_path?: string;
    reset_token?: string;
};

export type IRequestDataRelationships = {
    data?: {
        relationships?: IRequestRelationships;
    };
};

export type IRequestDataFileBody = {
    [id: string]: string;
};
export type IRequestDataFile = {
    gateway?: string;
};
export type IRequestDataItems = {
    data?: IRequestMainAttributesItem | IRequestMainAttributesItem[];
};

export type IRequestOrderBody = {
    order?: {
        [key: string]: string;
    };
};
export type IRequestRateDataInfo = {
    sales_rate_list?: IRateListRequestAPIV2;
};
export type IRequestSubscribersFeatures = {
    features?: IMultiEnabled;
    subscriber_ids?: number[];
};
export type IRequestUpdateCompanySubscribersMigrate = {
    migrated?: boolean;
};
export type IRequestUpdateNotificationsItem = {
    read?: boolean;
};

export type IRequestTariffPackageInstanceAPI = {
    tariff_package_instance?: IRequestTariffPackageInstanceItemAPI;
};

export type IRequestCardSetReassign = {
    target_company_id?: string;
    effective_date?: string;
    target_card_set_id?: string;
    create_card_set?: boolean;
};

export type IRequestBodyV2 =
    | IApproveMonthlyOrderAPI
    | IRequestCardSetReassign
    | IMonthlyOrderPostLinkUnlinkAPI
    | IMonthlyOrderPostPoNumber
    | IRequestOrderBody
    | IRequestRateDataInfo
    | IRequestTariffPackageInstanceAPI
    | IRequestSubscribersFeatures
    | IRequestUpdateCompanySubscribersMigrate
    | IRequestUpdateNotificationsItem;

export type IRequestData = IRequestDataFile & IRequestDataItems & IRequestBodyV2 & IRequestDataRelationships;

export type IRequestAPIBody = IRequestData &
    IRequestAuthBody & {
        totp?: string;
        included?: IRequestIncludedItem[];
    };

export type IApiManagerAppSignal = {
    apiParams: IGetApiParams;
    apiType: IGetApiType;
};
export type IApiManagerAppSignalError = IApiManagerAppSignal & {
    error: Error;
    description?: string;
};

export type IApiManagerAppSignalResponse = IApiManagerAppSignal & {
    response: Response;
};

export type IApiManagerAppSignalResponse401 = Omit<IApiManagerAppSignalResponse, 'apiType'>;
